import { useState, useEffect } from "react";
import SbuxEnhancedTable from "../../../../components/SbuxTable/SbuxEnhancedTable";
import { TRANSCRIPTS_COLUMN_NAME } from "../../../../constants";
import Row from "../common/Row";
import { masterColumns } from "./columns";
import SbuxLoader from "../../../../components/SbuxLoader";

interface MasterTableProps {
  historyData: Record<string, unknown>[] | null | undefined;
  historyLoading: boolean | undefined;
  handleRefrehClick: () => void;
  areTranscriptsEnabledForInstance: boolean;
}

const MasterTable = ({
  historyData,
  historyLoading,
  handleRefrehClick,
  areTranscriptsEnabledForInstance,
}: MasterTableProps) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  }, []);

  const columns = areTranscriptsEnabledForInstance
    ? masterColumns
    : masterColumns.filter(
        (masterColumn) => ![TRANSCRIPTS_COLUMN_NAME].includes(masterColumn.id),
      );

  return (
    <>
      {historyLoading ? (
        <SbuxLoader />
      ) : (
        <SbuxEnhancedTable
          rows={historyData ?? undefined}
          columns={columns}
          groupColumns={null}
          defaultSortingField={"timestamp"}
          RowSource={Row}
          handleRefreshClick={handleRefrehClick}
          isLoading={isLoading}
          showRefreshButton={true}
          footerMarginBottom={"0"}
        />
      )}
    </>
  );
};

export default MasterTable;
